import {Typography} from '@hconnect/uikit'
import {TextField} from '@material-ui/core'
import {Box} from '@mui/material'
import clsx from 'clsx'
import React from 'react'
import {Controller} from 'react-hook-form'

import {handleNoSpecialCharacters} from '../../../common/utils/handleNoSpecialCharacters'
import {useStyles} from '../../../components/UserInformation/inputs/UserInput.styles'
import {useTranslation} from '../../../hooks/useTranslation'

import {WidgetInputsProps} from './WidgetInputs.types'

type WidgetCompanyInputProps = WidgetInputsProps

export const WidgetCompanyInput = ({formMethods}: WidgetCompanyInputProps) => {
  const {t} = useTranslation()

  const inputClasses = useStyles()

  return (
    <Controller
      name="companyName"
      control={formMethods.control}
      rules={{validate: (value) => (value ? handleNoSpecialCharacters(value, t) : true)}}
      render={({field}) => (
        <Box style={{display: 'flex', flexDirection: 'column'}}>
          <TextField
            {...field}
            onChange={(event) => field.onChange(event)}
            data-test-id={`widgetUserCreation-${field.name}`}
            className={clsx({
              [inputClasses.quickPreviewTextField]: true,
              [inputClasses.quickPreviewTextFieldError]: !!formMethods.formState.errors.companyName
            })}
            fullWidth
            label={t('widgetUserCreation.form.companyName')}
            margin="normal"
            error={!!formMethods.formState.errors.companyName}
            InputProps={{disableUnderline: true}}
            InputLabelProps={{shrink: true}}
          />
          {!!formMethods.formState.errors.companyName && (
            <Typography
              variant="caption"
              style={{color: 'rgba(218, 9, 1, 1)', padding: '0 8px', marginBottom: '4px'}}
            >
              {formMethods.formState.errors.companyName?.message}
            </Typography>
          )}
        </Box>
      )}
    />
  )
}
